import { useTranslation } from '@dreamstack/i18n'
import { ArrowRight } from '@dreamstack/icons'
import type { NewsArticleFileFragment } from '@dreamstack/investors-graphql'
import { motion } from 'framer-motion'
import Link from 'next/link'
import type { FunctionComponent } from 'react'
import 'twin.macro'
import tw, { styled } from 'twin.macro'
import {
  AnimateIconTranslationRight,
  useAnimateIconTranslationRight,
} from '../index'
import { NewsArticleFile } from './NewsArticleFile'

const StyledLink = styled(motion.a)<{ $whiteText?: boolean }>(
  ({ $whiteText }) => [
    $whiteText
      ? tw`text-accentroWhite-full mt-px-6`
      : tw`text-accentroAqua-full mt-px-32`,
    tw`flex items-center font-semibold text-px-16 leading-px-24 ml:(text-px-20 leading-px-30)`,
  ]
)

export const ContinueReadingLink: FunctionComponent<
  React.PropsWithChildren<{
    whiteText?: boolean
    href: string
    file?: NewsArticleFileFragment['file']
    onClick?: () => void
  }>
> = ({ whiteText, href, file, onClick }) => {
  const t = useTranslation()
  const { controls, onHoverStart } = useAnimateIconTranslationRight()
  return (
    <>
      {!!file ? (
        <NewsArticleFile file={file} whiteText={whiteText} />
      ) : (
        <Link href={href} passHref legacyBehavior>
          <StyledLink
            onClick={onClick}
            onHoverStart={onHoverStart}
            $whiteText={whiteText}
          >
            {t('accentro:continueReading')}{' '}
            <AnimateIconTranslationRight animate={controls}>
              <ArrowRight tw="w-px-32 h-px-32 ml-px-12" />
            </AnimateIconTranslationRight>
          </StyledLink>
        </Link>
      )}
    </>
  )
}
